var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary","size":"64","width":"4"}}),_c('span',[_vm._v("Cargando...")])],1):(!_vm.development)?_c('div',[_c('span',[_vm._v("No se encontró la información")])]):_c('DevelopmentDetail',{attrs:{"development":_vm.development}})
}
var staticRenderFns = []

export { render, staticRenderFns }